import { render, staticRenderFns } from "./refundUpdateDetail.vue?vue&type=template&id=38c0216c&scoped=true&"
import script from "./refundUpdateDetail.vue?vue&type=script&lang=js&"
export * from "./refundUpdateDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundUpdateDetail.vue?vue&type=style&index=0&id=38c0216c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0216c",
  null
  
)

export default component.exports